<template>
  <div>
    <div class="text-center depahead rsu">ยืนยันตัวตน</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 60px; padding-top: 10px">
        <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
      </div>
      <v-container>
        <ValidationObserver ref="observer">
          <div class="mb-6" style="font-weight: 600; font-size: 22px">
            ยืนยันตัวตน
          </div>
          <div>
            <ValidationProvider name="รูปโปรไฟล์" :key="'รูปโปรไฟล์'" :rules="{ required: false }" v-slot="{ errors }">
              <upload-profile :errors="errors" v-model="input.profile_pic" :height="120"></upload-profile>
            </ValidationProvider>
          </div>
          <div>
            <div style="color: grey">ID CARD</div>
            <ValidationProvider name="ID CARD" :key="'ID CARD'" rules="required|IDCARD" v-slot="{ errors }">
              <v-text-field type="tel" name="idcard" v-mask="'#############'" :error-messages="errors" v-model="input.id_card" outlined dense></v-text-field>
            </ValidationProvider>
            <div style="color: grey">ชื่อ - นามสกุล</div>
            <ValidationProvider name="ชื่อ - นามสกุล" :key="'ชื่อ - นามสกุล'" :rules="{ required: true }" v-slot="{ errors }">
              <v-text-field v-model="input.name" :error-messages="errors" outlined dense></v-text-field>
            </ValidationProvider>
            <div style="color: grey">วันเดือนปีเกิด</div>
            <v-flex xs12 sm6>
              <v-radio-group v-model="onlyYear" @change="resetDate">
                <v-radio label="กรอกวันเดือนปีเกิด" value="dmy"></v-radio>
                <v-radio label="กรอกเฉพาะเดือนและปีเกิด" value="my"></v-radio>
                <v-radio label="กรอกเฉพาะปีเกิด" value="y"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-dialog v-if="onlyYear == 'dmy'" ref="dialog" v-model="modaldob" :return-value.sync="input.dob" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider
                  name="วันเกิด"
                  :rules="{
                    required: true,
                  }"
                  v-slot="{ errors }"
                >
                  <v-text-field :error-messages="errors" :value="formatedDate" readonly v-bind="attrs" v-on="on" placeholder="DD/MM/YYYY" outlined dense></v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker color="primary" locale="th-th" v-model="input.dob" scrollable class="Kanit">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modaldob = false">
                  ยกเลิก
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(input.dob)">
                  ตกลง
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <ValidationProvider v-else-if="onlyYear == 'y'" name="ปีเกิด" rules="required" v-slot="{ errors }">
              <v-text-field type="number" placeholder="2470" v-mask="'XXXX'" :error-messages="errors" v-model="input.dob" outlined dense></v-text-field>
            </ValidationProvider>
            <v-layout v-else-if="onlyYear == 'my'" row wrap>
              <v-flex xs4 class="pr-0">
                <ValidationProvider name="เดือนเกิด" rules="required" v-slot="{ errors }">
                  <v-text-field type="number" placeholder="01" v-mask="'XX'" :error-messages="errors" v-model="myData.m" outlined dense></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs8>
                <ValidationProvider name="ปีเกิด" rules="required" v-slot="{ errors }">
                  <v-text-field type="number" placeholder="2470" v-mask="'XXXX'" :error-messages="errors" v-model="myData.y" outlined dense></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>

            <!-- <div style="color: grey">
              เลขหลังบัตร (พิมพ์ตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก)
            </div>
            <ValidationProvider name="เลขหลังบัตร" rules="required|lasor_no" v-slot="{ errors }">
              <v-text-field @paste="isLetter($event)" @input="input.laser_no = $event.toUpperCase()" placeholder="AA0-0000000-00" v-mask="'XXX-XXXXXXX-XX'" :error-messages="errors" v-on:keypress="isLetter($event)" :value="input.laser_no.toUpperCase()" outlined dense></v-text-field>
            </ValidationProvider> -->
            <!-- <div v-if="documentList && documentList.length"> -->
            <!-- <v-layout justify-space-between v-if="documentList && documentList.length">
                <div style="color: grey">อัปโหลดเอกสาร</div>
                <span @click="showDoc = true" style="color: blue; cursor: pointer;margin-bottom: 5px;text-decoration: underline;">รายการเอกสารที่ต้องอัปโหลด</span>
              </v-layout> -->
            <!-- <div style="display: flex; flex-direction: row">
                <div style="width: 100%">
                  <ValidationProvider name="เอกสาร" :key="'เอกสาร'" v-slot="{ errors }">
                    <UploadDocument :errors="errors" v-model="input.document"></UploadDocument>
                  </ValidationProvider>
                </div>
              </div>
              <input style="height: 0px; width: 0px; visibility: hidden" type="file" ref="fileuploadinput" />
            </div> -->
          </div>
          <div class="flex-all-center mb-4">
            <v-flex xs12>
              <v-btn :loading="loading" @click="saveDraft" class="text-capitalize w-max" block>Save Draft</v-btn>
            </v-flex>
          </div>
          <v-layout row justify-space-between>
            <v-flex class="submitbtn">
              <v-btn :loading="loading" @click="back" class="text-capitalize w-max" block>Back</v-btn>
            </v-flex>
            <v-flex class="submitbtn">
              <v-btn :loading="loading" @click="verify" class="text-capitalize" color="primary" block>Confirm</v-btn>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-container>
      <!-- <v-dialog v-model="showDoc" scrollable persistent max-width="500px" transition="dialog-transition">
        <v-card>
          <div class="text-right">
            <v-btn @click="showDoc = false" icon><v-icon>close</v-icon> </v-btn>
          </div>
          <div class="pa-5">
            <h5>รายการเอกสารที่ต้องอัปโหลด</h5>
            <div v-for="(item, index) in documentList" :key="`doc-list-${index}`">{{ index + 1 }}. {{ item }}</div>
          </div>
        </v-card>
      </v-dialog> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UploadProfile from "../../components/UploadProfile.vue";
//import UploadDocument from "../../components/UploadDocumentProfile.vue";
import moment from "moment";
import { extend } from "vee-validate";
extend("IDCARD", (value) => {
  if (value.length == 13) {
    return true;
  }
  return "กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง";
});
extend("lasor_no", (value) => {
  if (value.length == 14) {
    return true;
  }
  return "กรุณากรอกเลขหลังบัตรให้ถูกต้อง";
});
export default {
  components: {
    UploadProfile,
    // UploadDocument 
  },

  data() {
    return {
      myData: {
        m: "",
        Y: "",
      },
      onlyYear: "dmy",
      showDoc: false,
      loading: false,
      input: {
        id_card: "",
        name: "",
        dob: "",
        // laser_no: "",
        profile_pic: "",
        // document: "",
      },
      modaldob: false,
    };
  },
  watch: {
    myData: {
      deep: true,
      immediate: true,
      handler(myData) {
        if (myData.m && myData.y) {
          this.input.dob = `${myData.y}-${myData.m}-0`;
        }
      },
    },
  },
  computed: {
    formatedDate() {
      if (this.input.dob) {
        return moment(this.input.dob)
          .locale("th")
          .format("LL");
      } else return "";
    },
    selectType() {
      return this.$store.state.input;
    },
    // documentList() {
    //   return this.selectType.document ? this.selectType.document.split(",") : [];
    // },
    dataD() {
      return this.$store.state.profiledata;
    },
  },
  mounted() {
    let draft = Vue.localStorage.get("regisDataRegular");
    draft = draft ? JSON.parse(draft) : null;
    if (draft) {
      this.input = draft;
    } else if (this.dataD && this.dataD.id_card) {
      this.input = {
        id_card: this.dataD.id_card,
        name: this.dataD.name,
        dob: this.dataD.dob,
        // laser_no: "",
        profile_pic: this.dataD.profile_pic,
        // document: this.dataD.document,
      };
    }
  },
  methods: {
    resetDate() {
      this.input.dob = null;
      this.myData = {
        m: "",
        Y: "",
      };
    },

    cleardob() {
      this.input.dob = "";
    },
    back() {
      this.query.view = "Verifyinfo";
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z0-9]+$/.test(char) && !/(​|“|”|‘|’)/gim.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async verify() {
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        let body = {
          ...this.$store.state.profiledata,
          ...this.input,
          memberid: this.$store.state.memberid,
          // laser_no: this.input.laser_no.replace(/-/g, ""),
        };
        if (body.dob.length <= 4) {
          body.dob = `${parseInt(body.dob) - 543}-00-00`;
        }
        var status = await this.$store.dispatch("depamemberinfo_verification", body);
        if (status == 200) {
          Vue.localStorage.remove("regisDataRegular");
          await this.$liff.closeWindow();
        }
        this.loading = false;
      }
    },
    async saveDraft() {
      this.loading = true;
      let body = {
        ...this.input,
      };
      try {
        Vue.localStorage.set("regisDataRegular", JSON.stringify(body));
        this.loading = false;
        await this.$swal.fire({
          icon: "success",
          text: "บันทึกสำเร็จ",
        });
      } catch (error) {
        await this.$swal.fire({
          icon: "error",
          text: "บันทึกไม่สำเร็จ",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
